// AUTH ACCESS LAYER
// All new features MUST use this adapter instead of importing
// firebase/auth directly. Wraps Firebase Auth today.
// See ARCHITECTURE_AUDIT.md (RW-352) for context.

import {
  onAuthStateChanged as fsOnAuthStateChanged,
  signOut as fsSignOut,
  signInWithPopup as fsSignInWithPopup,
  signInWithEmailAndPassword as fsSignInWithEmailAndPassword,
  createUserWithEmailAndPassword as fsCreateUserWithEmailAndPassword,
  sendPasswordResetEmail as fsSendPasswordResetEmail,
} from 'firebase/auth';
import { auth, provider } from '../firebase';

export function getCurrentUser() {
  return auth.currentUser;
}

export function onAuthStateChanged(callback) {
  return fsOnAuthStateChanged(auth, callback);
}

export function signOut() {
  return fsSignOut(auth);
}

export function signInWithGoogle() {
  return fsSignInWithPopup(auth, provider);
}

export function signInWithEmail(email, password) {
  return fsSignInWithEmailAndPassword(auth, email, password);
}

export function createUserWithEmail(email, password) {
  return fsCreateUserWithEmailAndPassword(auth, email, password);
}

export function sendPasswordReset(email) {
  return fsSendPasswordResetEmail(auth, email);
}

export async function getIdTokenResult(forceRefresh = false) {
  const u = auth.currentUser;
  return u ? u.getIdTokenResult(forceRefresh) : null;
}
